import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Entite} from './entite.model';
import {tap} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class EntiteService extends DaoGeneric<Entite> {
  private url = `${environment.baseUrl}/gestion_universite/services_composantes/`;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(): string {
    return this.url;
  }
  public createBulk(entites: Entite[]) {
    const url = `${this.url}createBulk/`;
    return this.httpClient.post(url, entites);
  }
  public sortBy(entites: Entite[], property = 'name') {
    entites.sort((x, y) => (x.entite_obj[property] < y.entite_obj[property] ? -1 : 1));
  }

  /**
   * Entités par type et triées
   * @param type : entiteTypeEnum.cmp ou entiteTypeEnum.dir ou entiteTypeEnum.cmp | entiteTypeEnum.dir
   */
  public fetchSvcCmp(type: number) {
    const extraParams: Map<string, string> = new Map<string, string>([['by_type', type.toString()]]);
    return this.listAllItems(extraParams).pipe(tap(_data => this.sortBy(_data.list)));
  }

  public getEntiteCode(type: number){
    const entiteCodes = {1: 'cmp', 2: 'adm'};
    return entiteCodes[type];
  }

  public getEntiteLabel(type: number){
    const entiteLabels = {1: 'composantes', 2: 'services'};
    return entiteLabels[type];
  }
}
